import {PageService,PreviewService} from 'hasta-la-vista-middleware-api/service'
import MetaData from  '../../../mixins/meta-data.js'

export default {
    mixins: [MetaData],

    data(){
        return {
            newsItems: [],
            loading: true,
            newsFilter:'All'
        }
    },

    created(){
        this.loading = true;
        PageService.getNews().then((newsItems)=> {
            this.newsItems = PreviewService.addPreviewToContentArrayIfAvailable('news',newsItems);
            let newsFilter = (this.$route.params.filter ? this.$route.params.filter: 'All')

            this.newsFilter = newsFilter
            this.loading = false;
        })
        this.metaTitle = 'Movie and Entertainment News | The Latest in Cinema'
        this.metaDescription = 'Stay up to date with the latest Ster-Kinekor movie and entertainment news. Browse our corporate news articles and press releases.'
    },

    mounted() {
        window.scroll({top: 0, left: 0})
        if (window.__PRERENDER_INJECTED) {
            if(window.__PRERENDER_INJECTED.news) {
                this.newsItems = PreviewService.addPreviewToContentArrayIfAvailable('news',window.__PRERENDER_INJECTED.news);
                let newsFilter = 'All'
                this.metaTitle = 'Movie and Entertainment News | The Latest in Cinema'
                this.metaDescription = 'Stay up to date with the latest Ster-Kinekor movie and entertainment news. Browse our corporate news articles and press releases.'
            }
        }
    }
}



// WEBPACK FOOTER //
// ./src/components/pages/news/news.js